
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCode, faFileEdit, faFile, faRobot, faQuestion, faFileLines } from '@fortawesome/free-solid-svg-icons';
import Util from './Util';

function HtmlIcon({ filename, auth, tType}) {

  let backgroundColor="lightgray";

  /*
  if(tType == "dashboard")
  {
    if(filename===auth.user.workingHtml)
    {
      backgroundColor="green";
    }
  }
  */

  const renderIcon = () =>
  {
    let match = filename.match(/^([a-zA-Z0-9_-]+)(\.html)$/);

    if(match)
    {
      return (
        <FontAwesomeIcon icon={faFileCode} style={{ width: '70%', height: '70%' }} />
      )

    }

    /*
    if(match && filename===auth.user.workingHtml)
    {

      return (
          <FontAwesomeIcon icon={faFileEdit} style={{ width: '70%', height: '70%' }} />
      )
    }
    if(match && filename!==auth.user.workingHtml)
    {

      return (
        <FontAwesomeIcon icon={faFileCode} style={{ width: '70%', height: '70%' }} />
          
      )
    }
    */


    let ut = Util.getInstance();
    if(ut.isAitFile(filename))
    {
      return (
        <FontAwesomeIcon icon={faFileLines} style={{ width: '70%', height: '70%' }} />
          
      )

    }

    return (
      <FontAwesomeIcon icon={faQuestion} style={{ width: '70%', height: '70%' }} />
    )

  }
  return (
    <div 
      className="html-icon" 
      style={{ 
        width: '100%', 
        height: '100%', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        backgroundColor: backgroundColor
      }}
    >

      {renderIcon()}
      {
        /*
      (filename.match(/^([a-zA-Z0-9_]+)(\.html)$/)) ? (      
        <FontAwesomeIcon icon={faFileCode} style={{ width: '70%', height: '70%' }} /> ) :
        (<FontAwesomeIcon icon={faFileEdit} style={{ width: '70%', height: '70%' }} />)
        */
      }

      {/*
      filename === 'index.html' || filename.match(/^(?:[a-zA-Z0-9]+_)?i\d+\.html$/) ? (
        <FontAwesomeIcon icon={faFileCode} style={{ width: '70%', height: '70%' }} />
      ) : filename === 'form.html' || filename.match(/^(?:[a-zA-Z0-9]+_)?f\d+\.html$/)? (
        <FontAwesomeIcon icon={faFileEdit} style={{ width: '70%', height: '70%' }} />
      ) : (
        <FontAwesomeIcon icon={faRobot} style={{ width: '70%', height: '70%' }} />
      ) */}
    </div>
  );
}

export default HtmlIcon;

